<template lang="pug">
  component(:is="dialogMode ? 'div' : 'd2-container'")
    div(style="text-align: right; margin: 10px 16px 0 0;")
      el-button(type="primary" :disabled="!hasPersonData" @click="openBatchDialog") 人工批量生成培训班
    // 顶部培训组信息卡片
    el-card(shadow="hover" style="margin: 10px 16px;")
      div(slot="header" style="font-weight: bold;") 当前培训组
      div(style="margin-bottom: 8px; font-size: 16px;")
        span {{ info.trainCode }}
        span  |
        span {{ info.name }}
      div(style="color: #909399; font-size: 14px;")
        span 本页待分班人员、培训班和调班操作均限定在当前培训组范围内。
        span  当前整组阶段：
        span(style="color: #67c23a; cursor: pointer;") {{ pxState[this.statePre] }}

    // 项目人员区域
    div(style="display: flex; padding: 0 16px; font-size: 16px;")
      // 左侧待分班人员
      div(style="width: 260px; border: 1px solid #e8e8e8; border-radius: 4px; margin-right: 16px; background: #fafafa;")
        div(style="padding: 14px; font-weight: bold; border-bottom: 1px solid #e8e8e8; font-size: 16px;") 待分班人员
        div(style="padding: 14px; color: #999; font-size: 14px;" v-if="!personList.length") 暂无待分班人员
        div(style="padding: 10px 14px;")
          div(v-for="p in personList" :key="p.id" @click="selectPerson(p)" :style="{display: 'inline-block', background: selectedPerson && selectedPerson.id === p.id ? '#1890ff' : '#e6f7ff', color: selectedPerson && selectedPerson.id === p.id ? '#fff' : '#1890ff', padding: '6px 12px', border: selectedPerson && selectedPerson.id === p.id ? '1px solid #1890ff' : '1px solid #91d5ff', borderRadius: '4px', marginRight: '8px', marginBottom: '8px', fontSize: '14px', cursor: 'pointer'}") {{ p.name }}

      // 右侧班级列表
      div(style="flex: 1;")
        div(v-for="(item, idx) in createdClassList" :key="item.classCode || idx" style="border: 1px solid #e8e8e8; border-radius: 4px; margin-bottom: 12px; background: #fff;")
          div(style="padding: 14px; border-bottom: 1px solid #e8e8e8; display: flex; align-items: center;")
            span(style="font-weight: bold; margin-right: 10px; font-size: 16px;") {{ item.classCode }} · {{ item.className }}
            span(style="background: #52c41a; color: #fff; padding: 3px 10px; border-radius: 10px; font-size: 14px;") 已发布
          div(style="padding: 14px;")
            div(style="margin-bottom: 14px; color: #999; font-size: 14px;") 班级人数：{{ item.students.length }}/{{ item.capacity }}|教练：{{ item.coachName || '未指定' }}
            div(style="margin-bottom: 14px;")
              span(v-for="s in item.students" :key="s.id" @click="selectStudent(idx, s)" :style="{display: 'inline-block', background: selectedStudent && selectedStudent.classIdx === idx && selectedStudent.person.id === s.id ? '#1890ff' : '#e6f7ff', color: selectedStudent && selectedStudent.classIdx === idx && selectedStudent.person.id === s.id ? '#fff' : '#1890ff', padding: '6px 12px', border: selectedStudent && selectedStudent.classIdx === idx && selectedStudent.person.id === s.id ? '1px solid #1890ff' : '1px solid #91d5ff', borderRadius: '4px', marginRight: '8px', marginBottom: '8px', fontSize: '14px', cursor: 'pointer'}") {{ s.name }}
              span(v-if="!item.students.length" style="color: #bbb; font-size: 13px;") 暂无人员
            div(style="border-top: 1px dashed #e8e8e8; padding-top: 14px;")
              el-button( @click="openEditDialog(idx)") 编辑
              el-button(type="primary" :disabled="!selectedPerson" @click="assignPersonToClass(idx)") 分配到本班
              el-button(:disabled="!selectedStudent || selectedStudent.classIdx !== idx" @click="moveBackToWaiting") 移回待分班区域

        // 底部提示区域
    el-card(shadow="hover" style="margin-top: 20px; margin-left: 16px; margin-right: 16px;")
      div(slot="header" style="font-weight: bold;") 发布说明
      div(style="margin-bottom: 6px;")
        span(style="font-weight: bold;") 发布对象：
        span 当前培训组下全部二级培训班。三级课程随所属培训班生效，不单独发布。
      div
        span(style="font-weight: bold;") 发布去向：
        span 分级整期培训列表。
    // 右下角状态和按钮
    div(style="display: flex; justify-content: flex-end; align-items: center; padding: 12px 16px;")
      span(style="color: #999; margin-right: 12px; font-size: 13px;") 当前培训组下全部培训班已发布
      el-button(type="success" :disabled="!hasPersonData" :loading="publishLoading" @click="publishAllClasses") 发布全部培训班
    // 人工批量生成培训班弹窗
    el-dialog(title="人工批量生成培训班" :visible.sync="batchDialogVisible" width="800px" :append-to-body="dialogMode" :modal-append-to-body="false" :close-on-click-modal="false" @close="batchDialogCancelClose")
      el-form(ref="batchFormRef" :model="batchForm" :rules="batchRules" label-width="120px")
        el-form-item(label="新增班级数量" prop="classCount" required)
          el-input-number(v-model="batchForm.classCount" :min="1" :max="6" @change="onClassCountChange")
        // 提示信息
        div(style="background:#e6f7ff;color:#1890ff;padding:10px 14px;border:1px solid #91d5ff;border-radius:4px;margin-bottom:16px;font-size:13px;line-height:1.6;")
          span 当前培训组：
          span(style="color:#1890ff;font-weight:bold;") {{ info.trainCode }} |
          span(style="color:#1890ff;font-weight:bold;") {{ info.name }}
          br
          span 填写班级数量后，逐班配置名称、容量和现有教练；生成后会创建对应培训班及完整课程。
        // 动态班级配置
        div(v-for="(cls, idx) in batchForm.classList" :key="idx" style="border:1px solid #e8e8e8;border-radius:4px;padding:16px;margin-bottom:12px;background:#fafafa;")
          div(style="font-weight:bold;margin-bottom:12px;font-size:15px;") 第 {{ idx+1 }} 班 · {{ cls.defaultCode }}
          el-row(:gutter="16")
            el-col(:span="12")
              el-form-item(label="培训班名称" :prop="'classList.'+idx+'.className'" :rules="batchRules.className")
                el-input(v-model="cls.className" placeholder="请输入培训班名称")
            el-col(:span="12")
              el-form-item(label="班级人数" :prop="'classList.'+idx+'.capacity'" :rules="batchRules.capacity")
                el-input-number(v-model="cls.capacity" :min="1" :max="50" style="width:100%;")
          el-form-item(label="教练" :prop="'classList.'+idx+'.coachId'" :rules="batchRules.coachId")
            el-select(v-model="cls.coachId" placeholder="请选择教练" filterable style="width:100%;")
              el-option(v-for="coach in coachList" :key="coach.id" :label="coach.name + (coach.coachLevel ? ' · PTR ' + coach.coachLevel : '')" :value="coach.id")
      span.dialog-footer(slot="footer")
        el-button(@click="batchDialogVisible=false") 取消
        el-button(type="primary" :loading="submitLoading" @click="submitBatchClasses") 确认生成
      
    // 编辑培训班弹窗组件
    edit-class-dialog(v-if="editDialogVisible" ref="editDialog" :coach-list="coachList" @confirm="onEditConfirm")
</template>

<script>
import commonData from '../common.js'
import EditClassDialog from './EditClassDialog.vue'

export default {
  name: 'train-class-adjust',
  props: {
    dialogMode: {
      type: Boolean,
      default: false
    },
    trainGroup: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      statePre: '',
      info: {
        trainGroupCode: '',
      },
      pxState: commonData.pxState2,
      // 弹窗相关
      batchDialogVisible: false,
      submitLoading: false,
      publishLoading: false,
      editDialogVisible: false,
      coachList: [],
      personList: [],
      hasPersonData: false,
      selectedPerson: null,
      selectedStudent: null,
      createdClassList: [],
      batchForm: {
        classCount: 1,
        classList: []
      },
      batchRules: {
        className: [{ required: true, message: '请输入培训班名称', trigger: 'blur' }],
        capacity: [{ required: true, message: '请输入容量', trigger: 'blur' }],
        coachId: [{ required: true, message: '请选择教练', trigger: 'change' }]
      }
    }
  },
  components: {
    EditClassDialog
  },
  mounted () {
    if (this.dialogMode) {
      this.init(this.trainGroup)
    } else {
      const query = this.$route.query || {}
      this.init({
        id: query.trainGroupCode,
        state: query.statePre
      })
    }
    this.loadCoachList()
  },
  methods: {
    init (row) {
      if (!row || row.id === undefined || row.id === null) return
      this.statePre = row.state || ''
      this.info = Object.assign({ trainGroupCode: '' }, row)
      this.batchDialogVisible = false
      this.submitLoading = false
      this.publishLoading = false
      this.editDialogVisible = false
      this.personList = []
      this.hasPersonData = false
      this.selectedPerson = null
      this.selectedStudent = null
      this.createdClassList = []
      this.batchForm.classCount = 1
      this.batchForm.classList = []
      this.getDetail(row.id)
      this.getPersonList(row.id)
    },
    getDetail (id) {
      this.$http({
        url: this.$http.adornUrl(`/pxTrain/getId/${id}`),
        method: 'get'
      }).then((data) => {
        if (data && data.code === 0 && data.bean) {
          this.info = data.bean
        }
      })
    },
    // 获取待分班人员列表
    getPersonList (id) {
      this.hasPersonData = false
      this.$http({
        url: this.$http.adornUrl('/pxTrainPerson/list'),
        method: 'post',
        data: {
          page: 1,
          limit: 99999,
          state: 1,
          trainId: id
        }
      }).then((data) => {
        console.log('pxTrainPerson/list 返回值：', data)
        const records = data && data.code === 0 && data.page && Array.isArray(data.page.records)
          ? data.page.records
          : []
        this.personList = records
        this.hasPersonData = records.length > 0
      }).catch(() => {
        this.personList = []
        this.hasPersonData = false
      })
    },
    // 打开批量生成弹窗
    openBatchDialog () {
      this.batchDialogVisible = true
      this.batchForm.classCount = 1
      this.onClassCountChange(1)
    },
    // 加载教练列表
    loadCoachList () {
      return this.$http({
        url: this.$http.adornUrl('/pxCoach/list'),
        method: 'post',
        data: { page: 1, rows: 999, limit: 999 }
      }).then((data) => {
        if (data && data.code === 0) {
          this.coachList = (data.page && data.page.records) || []
        }
      })
    },
    // 班级数量变化时更新班级列表
    onClassCountChange (count) {
      const trainCode = this.info.trainCode || this.info.trainGroupCode || ''
      const defaultCapacity = this.info.classCount
      const coachList = this.info.trainCoachList || []
      const existing = this.batchForm.classList.length
      if (count > existing) {
        for (let i = existing; i < count; i++) {
          const letter = String.fromCharCode(65 + i) // A, B, C...
          const preCoach = coachList.length ? coachList[i % coachList.length] : null
          this.batchForm.classList.push({
            defaultCode: trainCode + '-' + letter,
            className: '新建' + letter + '班',
            capacity: defaultCapacity,
            coachId: preCoach ? preCoach.coachId : null
          })
        }
        this.$nextTick(() => {
          this.batchForm.classList.forEach((cls, idx) => {
            if (!cls.coachId && coachList.length) {
              const c = coachList[idx % coachList.length]
              this.$set(cls, 'coachId', c.coachId)
            }
          })
        })
      } else if (count < existing) {
        this.batchForm.classList.splice(count)
      }
    },
    // 提交批量生成
    submitBatchClasses () {
      this.$refs.batchFormRef.validate((valid) => {
        if (!valid) return
        const createdItems = this.batchForm.classList.map(cls => {
          const c = (this.info.trainCoachList || []).find(t => t.coachId === cls.coachId) || (this.coachList || []).find(t => t.id === cls.coachId)
          return {
            classCode: cls.defaultCode,
            className: cls.className,
            capacity: cls.capacity,
            coachId: cls.coachId,
            coachName: c ? c.name : '',
            students: []
          }
        })
        this.createdClassList = this.createdClassList.concat(createdItems)
        this.batchDialogVisible = false
      })
    },
    // 弹窗关闭回调
    batchDialogCancelClose () {
      if (this.$refs.batchFormRef) {
        this.$refs.batchFormRef.clearValidate()
      }
    },
    // 选中待分班人员
    selectPerson (p) {
      this.selectedPerson = p
      this.selectedStudent = null
    },
    // 选中班级内人员
    selectStudent (classIdx, person) {
      this.selectedStudent = { classIdx, person }
      this.selectedPerson = null
    },
    // 把选中的人员分配到指定班级
    assignPersonToClass (idx) {
      if (!this.selectedPerson) return
      const cls = this.createdClassList[idx]
      if (!cls) return
      if (cls.students.length >= cls.capacity) {
        this.$message.warning('该班人数已满')
        return
      }
      if (cls.students.some(s => s.id === this.selectedPerson.id)) {
        this.$message.warning('该人员已在该班')
        return
      }
      cls.students.push({ id: this.selectedPerson.id, name: this.selectedPerson.name })
      this.personList = this.personList.filter(p => p.id !== this.selectedPerson.id)
      this.selectedPerson = null
    },
    // 把选中的班级内人员移回待分班区域
    moveBackToWaiting () {
      if (!this.selectedStudent) return
      const { classIdx, person } = this.selectedStudent
      const cls = this.createdClassList[classIdx]
      if (!cls) return
      cls.students = cls.students.filter(s => s.id !== person.id)
      this.personList.push({ id: person.id, name: person.name })
      this.selectedStudent = null
    },
    // 打开编辑弹窗
    openEditDialog (idx) {
      const cls = this.createdClassList[idx]
      if (!cls) return
      this._editClassIdx = idx
      if (!cls.courses || !cls.courses.length) {
        cls.courses = (this.info.trainCourseList || []).map(c => ({
          id: c.id,
          courseCode: c.code,
          date: c.trainTime,
          timeSlot: c.strTime + '-' + c.endTime,
          venueCode: c.placeCode,
          coachId: cls.coachId || null
        }))
      }
      this.editDialogVisible = true
      this.$nextTick(() => {
        this.$refs.editDialog.init(cls)
      })
    },
    // 编辑确认回调
    onEditConfirm (result) {
      const idx = this._editClassIdx
      const cls = this.createdClassList[idx]
      if (!cls) return
      cls.className = result.className
      cls.capacity = result.capacity
      cls.timeSlot = result.timeSlot
      cls.coachId = result.coachId
      cls.coachName = result.coachName
      cls.venueCode = result.venueCode
      cls.courses = (result.courses || []).map(c => ({ ...c }))
      this.$message.success('保存成功')
      this.editDialogVisible = false
    },
    // 发布全部培训班
    publishAllClasses () {
      if (!this.createdClassList.length) {
        this.$message.warning('暂无可发布的培训班')
        return
      }
      if (this.personList.length) {
        this.$message.warning('还有' + this.personList.length + '人需要分班，请先完成分班')
        return
      }
      const mapCourse = (c) => {
        const parts = String(c.timeSlot || '').split('-')
        return {
          id: c.id,
          code: c.courseCode,
          trainTime: c.date,
          strTime: parts[0] || c.strTime || '',
          endTime: parts[1] || c.endTime || '',
          placeCode: c.venueCode,
          coachId: c.coachId
        }
      }
      const subTrains = this.createdClassList.map(cls => {
        const courses = (cls.courses && cls.courses.length)
          ? cls.courses.map(mapCourse)
          : (this.info.trainCourseList || []).map(c => mapCourse({
              id: c.id,
              courseCode: c.code,
              date: c.trainTime,
              timeSlot: c.strTime + '-' + c.endTime,
              venueCode: c.placeCode,
              coachId: cls.coachId || null
            }))
        return {
          train: {
            classCode: cls.classCode,
            name: cls.className,
            classCount: cls.capacity,
            coachId: cls.coachId,
            coachName: cls.coachName || '',
            trainCoachList: [
              {
                name: cls.coachName || '',
                coachId: cls.coachId
              }
            ],
            timeSlot: cls.timeSlot || '',
            venueCode: cls.venueCode || '',
            trainCourseList: courses
          },
          personIds: cls.students.map(s => s.id)
        }
      })
      this.publishLoading = true
      this.$http({
        url: this.$http.adornUrl('/pxTrain/saveGroupSubTrains'),
        method: 'post',
        data: {
          groupId: this.info.id,
          subTrains
        }
      }).then((data) => {
        this.publishLoading = false
        if (data && data.code === 0) {
          this.$message.success('发布成功')
          if (this.dialogMode) {
            this.$emit('published')
          } else {
            this.$router.back()
          }
        } else {
          this.$message.error((data && data.msg) || '发布失败')
        }
      }).catch(() => {
        this.publishLoading = false
      })
    },
  }
}
</script>
